import CreditSuccess from "@assets/illustrations/credits/credit-success.svg?react";
import { Text, Dialog } from "@flat-ui";
import { Stack, SvgIcon } from "@mui/material";
import {
  CREDITS_DISPLAY_NAME,
  HAS_CREDIT_PURCHASED,
} from "@src/constants/credit-constants";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { useState } from "react";

/** Renders credit purchase success dialog */
export function CreditPurchaseSuccess(): JSX.Element {
  const hasCreditPurchased = localStorage.getItem(HAS_CREDIT_PURCHASED);

  const [shouldShowDialog, setShouldShowDialog] = useState<boolean>(
    hasCreditPurchased === "true"
  );

  function dialogConfirmCallback(): void {
    localStorage.removeItem(HAS_CREDIT_PURCHASED);
    setShouldShowDialog(false);
  }

  return (
    <Dialog
      open={shouldShowDialog}
      onConfirm={dialogConfirmCallback}
      confirmText="Got it"
      title=""
    >
      <SvgIcon
        inheritViewBox={true}
        component={CreditSuccess}
        sx={{
          width: "100%",
          height: "100%",
          fill: "none",
        }}
      />
      <Stack alignItems="center" gap={1.5}>
        <Text variant="heading24">Thanks for your purchase!</Text>

        <Text variant="bodyL" textAlign="center">
          {capitalizeFirstLetter(CREDITS_DISPLAY_NAME)} will be added soon
          (usually within 2 hours). <br />
          Contact support if there is more delay.
        </Text>
      </Stack>
    </Dialog>
  );
}
